import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './school.styles'
import Section from '../../../shared/section/section'
import Segments from '../../../shared/segments/segments'
import Details from './details/details.container'
import Request from './request/request.container'

class School extends Component {
  render() {
    const { inSchool, classes } = this.props
    return (
      <Section
        id="school"
        title="School relation and role selection"
        className={classes.section}>
        <Segments>
          {inSchool && <Details />}
          {!inSchool && <Request />}
        </Segments>
      </Section>
    )
  }
}

export default injectSheet(styles)(School)
